import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../../../redux/utils'


export const setWorkStatuses = (workStatuses) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.WORK_STATUSES_SET, workStatuses.items))
}

export const setInitialDefaultWorkStatus = (initialDefaultWorkStatus) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.INITIAL_DEFAULT_WORK_STATUS_SET, initialDefaultWorkStatus))
}

export const setDefaultWorkStatusPlanningData = (defaultWorkStatusPlanningData) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.DEFAULT_WORK_STATUS_PLANNING_DATA_SET, defaultWorkStatusPlanningData))
}




// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workStatuses/actions.js